import { useEffect, useMemo } from 'react';
import useGetGroups from '../../API/hooks/groups/useGetGroups';
import useGetFleetId from '../../API/hooks/useGetFleetId';
import DropdownFilter from '../common/DropdownFilter/DropdownFilter';
import S from './GroupSelectionStyles';

type GroupSelectionProps = {
  filters: Record<string, string[]>,
  setFilters: (args: any) => void,
};

function GroupSelection({
  filters, setFilters,
}: GroupSelectionProps): JSX.Element {
  const fleetId = useGetFleetId();
  const { data: groups } = useGetGroups(fleetId as string, '?limit=1000&skip=0');
  const options = useMemo(() => groups?.results?.map((group) => ({ [group._id]: group.name })) || [], [groups]);

  useEffect(() => {
    if (!groups?.results) {
      return;
    }

    const validGroupIds = new Set(groups.results.map((group) => group._id));
    const selectedIds = filters.groupIds ?? [];
    const validSelectedIds = selectedIds.filter((id) => validGroupIds.has(id));

    if (validSelectedIds.length !== selectedIds.length) {
      setFilters(validSelectedIds.length ? { groupIds: validSelectedIds } : {});
    }
  }, [groups?.results, filters.groupIds, setFilters]);
  return (
    <S.Wrapper>
      <DropdownFilter
        config={{
          options,
          type: 'groupIds',
        }}
        filters={filters}
        setFilters={setFilters}
      />
    </S.Wrapper>
  );
}

export default GroupSelection;
